(function() {
    angular.module('emarket.main.post').controller('PremiumProductListController', ['$scope', function($scope) {
        var vm = this;
        $scope.$watch('premiumPost', function() {
            if ($scope.premiumPost) {
                var posts = $scope.premiumPost.sort(function(a, b) {
                    return 0.5 - Math.random();
                });

                var totalPremium = 4 - $scope.premiumPost.length;
                var emptyPosts = [];
                for (var i = 0; i < totalPremium; i += 1) {
                    emptyPosts.push({
                        post: {
                            title: 'Espacio disponible para tu producto',
                            prices: {
                                list: null
                            },
                            images: [
                                {
                                    path: 'assets/available-premium.jpg'
                                }
                            ],
                            _id: '1000' + i
                        }
                    });
                }

                $scope.premiumPosts = posts.concat(emptyPosts);
            }
        });
        vm.onOpen = function($event, post, index) {
            $scope.onOpen($event, post, index);
        };
    }]);
}());
